// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"58d2efcf","526":"9f52d031"}[chunkId] + ".chunk.css";
};